module.exports = require('./helpers/bundle-url').getBundleURL('dj12v') + "placeholder.faea9478.svg";